import React from "react"
import "./ModalPopUp.scss"
import StarRedSvg from "@images/icon/star/icn-star-red.svg"
import h2ModalAdventCalendarSvg from "@images/h2-modal-advent-calendar.svg"
import { StaticImage } from "gatsby-plugin-image"

const ModalPopUp = ({
  handleOpenModal,
  showModalPopUp,
  handleCloseModalPopUp,
  todayDate,
}) => {
  return (
    <section
      className={`modal-second-day-access ${showModalPopUp ? "active" : ""}`}
    >
      <button
        className="modal-bg"
        aria-label="close"
        onClick={handleCloseModalPopUp}
      ></button>
      <button
        className="modal-close-button"
        aria-label="close"
        onClick={handleCloseModalPopUp}
      ></button>
      <div className="modal-container">
        <div className="modal-inner">
          <div className="ornament-star">
            <StaticImage
              src="../../images/icon/advent-calendar/ornament-star.png"
              alt=""
            />
          </div>
          <h2 className="advent-calendar-title">
            <div className="advent-calendar-title-img">
              <img src={h2ModalAdventCalendarSvg} alt="V4 Advent Calendar" />
            </div>
          </h2>
          <div className="star-red">
            <img src={StarRedSvg} alt="" />
          </div>
          <p className="second-day-access-text">Today’s Present</p>
          <a
            className={`second-day-access-img thumb-day${todayDate}`}
            onClick={() => {
              handleOpenModal(todayDate)
              handleCloseModalPopUp()
            }}
          ></a>
        </div>
      </div>
    </section>
  )
}

export default ModalPopUp
